<template>
    <div class="d-flex flex-shrink-1">
        <slot v-if="column_contoller_enabled"></slot>
        <v-menu
            close-on-click
            close-on-content-click
            content-class="overflow-y-hidden dropmenu"
            bottom
            offset-y
            style="max-width:36px"
            left
            min-width="220"
        >
            <template v-slot:activator="{ on }">
                <icon-button
                    :on="on"
                    icon="MoreVertical"
                    @click="emitSelectionShortcut($event)"
                />
            </template>
            <v-list dense>
                <v-list-item
                    class="menu-list-item"
                    style="height: 32px !important; min-height: 32px !important;"
                    @click="toggleSelectionCheckbox"
                >
                    <v-list-item-icon>
                        <icon icon="CheckCheck" />
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{
                                showSelectionCheckbox === true
                                    ? $t("Hide multiselect")
                                    : $t("Show multiselect")
                            }}
                        </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action v-if="textForOS !== ''">
                        <v-chip
                            label
                            class="tag"
                        >
                            {{ textForOS }}
                        </v-chip>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item
                    v-if="!searchMode"
                    class="menu-list-item"
                    style="height: 32px !important; min-height: 32px !important;"
                    @click="$emit('select_grouping', 'similar')"
                >
                    <v-list-item-icon>
                        <icon icon="Copy" />
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t("Group similar tasks") }}
                        </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action v-if="group_by === 'similar'">
                        <v-icon color="primary">mdi-check</v-icon>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item
                    class="menu-list-item"
                    style="height: 32px !important; min-height: 32px !important;"
                    @click="$emit('select_grouping', 'client')"
                >
                    <v-list-item-icon>
                        <icon icon="Copy" />
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t("Group by client") }}
                        </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action v-if="group_by === 'client'">
                        <v-icon color="primary">mdi-check</v-icon>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item
                    v-if="searchMode"
                    class="menu-list-item"
                    style="height: 32px !important; min-height: 32px !important;"
                    @click="$emit('select_grouping', 'date')"
                >
                    <v-list-item-icon>
                        <icon icon="Copy" />
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t("Group by date") }}
                        </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action v-if="group_by === 'date'">
                        <v-icon color="primary">mdi-check</v-icon>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item
                    v-if="searchMode"
                    class="menu-list-item"
                    style="height: 32px !important; min-height: 32px !important;"
                    @click="$emit('select_grouping', 'topic')"
                >
                    <v-list-item-icon>
                        <icon icon="Copy" />
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t("Group by topic") }}
                        </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action v-if="group_by === 'topic'">
                        <v-icon color="primary">mdi-check</v-icon>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item
                    class="menu-list-item"
                    style="height: 32px !important; min-height: 32px !important;"
                    @click="$emit('select_grouping', '')"
                >
                    <v-list-item-icon>
                        <icon icon="Copy" />
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t("Don't group") }}
                        </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action v-if="group_by === ''">
                        <v-icon color="primary">mdi-check</v-icon>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item
                    class="menu-list-item"
                    style="height: 32px !important; min-height: 32px !important;"
                    @click="
                        column_contoller_enabled = !column_contoller_enabled
                    "
                >
                    <v-list-item-icon>
                        <icon icon="Table" />
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t("Edit fields") }}
                        </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action v-if="column_contoller_enabled">
                        <v-icon color="primary">mdi-check</v-icon>
                    </v-list-item-action>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
import AppModule from "@/store/modules/app";
import { ref, computed, onMounted } from "@vue/composition-api";

export default {
    name: "DashboardDotMenu",
    props: {
        groupBy: {
            type: String,
            default: ""
            /*
            type: [String, Array],
            default: ""
            */
        },
        searchMode: {
            type: Boolean
        },
        showSelectionCheckbox: {
            type: Boolean,
            default: false,
        }
    },
    setup(props, { emit }) {
        const { setTextBasedOnOS, textForOS } = AppModule();

        const column_contoller_enabled = ref(false);
        const group_by = computed(() => {
            // if(Array.isArray(props.groupBy)) return props.groupBy.find(x => x)
            return props.groupBy;
        });

        onMounted(() => {
            setTextBasedOnOS();
        });

        function toggleSelectionCheckbox() {
            if (props.showSelectionCheckbox === false) {
                emit("bulkSelection", true);
            } else {
                emit("bulkSelection", false);
            }
        }

        function emitSelectionShortcut(event) {
            if (event.metaKey || event.ctrlKey) {
                toggleSelectionCheckbox();
            }
        }

        return {
            column_contoller_enabled,
            group_by,
            emitSelectionShortcut,
            textForOS,
            toggleSelectionCheckbox
        };
    }
};
</script>
